import GameStore from './GameStore.js';

const appStore = {};

appStore.gameStore = new GameStore(appStore);

export default appStore;
